<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="968" height="698" viewBox="0 0 968 698" fill="none" style="margin: 0 auto">
    <rect width="968" height="698" fill="white"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="525" y="643.28">Заочная форма</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="765" y="643.28">Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="473" y="597.22">Прогнозируемый объем КЦП
</tspan>
      <tspan x="479" y="613.457">для нестоличных регионов</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="706" y="597.22">Прогнозируемый объем КЦП для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="812" y="613.22">{{
        getPdData.sprRegionNameGenitive
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="566" y="565.18">{{
        getPdData.kcpR3
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" font-weight="bold" letter-spacing="0.01em"><tspan x="812" y="565.18">{{
        getPdData.kcp3
      }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="430" y="560.765">×</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="676" y="560.765">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="253" y="669.28">Все формы обучения</tspan></text>
<!--    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"-->
<!--          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="316" y="613.22">{{-->
<!--        getPdData.sprRegionNameGenitive-->
<!--      }}</tspan></text>-->
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="272" y="597.22">Доля региона</tspan>
      <tspan x="208" y="615.694">в суммарной потребности в КЦП</tspan>
      <tspan x="226" y="631.931">всех нестоличных регионов</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" letter-spacing="0.01em" font-size="47"
          font-family="Raleway" style="white-space: pre" xml:space="preserve" fill="#263238"><tspan y="565.18" x="318">{{ $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getPdData.dppr* 100) ? (getPdData.dppr === 'н.д.' ? 'н.д.': 'x'): getPdData.dppr * 100, 1, 'float', true,  'н.д.', '', (v) => v + '%') }}<!--{{         $scripts.TableJs.checkValueWithNullAndReturnND(getPdData.dppr, 3, 'float', true )   }}--></tspan></text>
    <path d="M111 478L111 480C111 484.418 114.582 488 119 488L174 488" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M612 478L612 480C612 484.418 608.418 488 604 488L404 488" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M318 499L318 496C318 491.582 314.418 488 310 488L171 488" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M318 499L318 496C318 491.582 321.582 488 326 488L407 488" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="423.514" y="465.28">Все формы обучения</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="384.312" y="424.22">Суммарная потребность в КЦП
</tspan>
      <tspan x="396.111" y="440.457">всех нестоличных регионов</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" letter-spacing="0.01em" font-size="47"
          font-family="Raleway" style="white-space: pre" xml:space="preserve" fill="#263238"><tspan y="392.18" x="486">{{
        getPdData.ppr
      }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="350" y="387.765">:</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="173.514" y="465.28">Все формы обучения</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="160.158" y="424.22">Потребность в КЦП для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="236" y="440.22">{{
        getPdData.sprRegionNameGenitive
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" letter-spacing="0.01em" font-size="47"
          font-family="Raleway" style="white-space: pre" xml:space="preserve" fill="#263238"><tspan y="392.18" x="236">{{
        getPdData.pbm
      }}</tspan></text>
    <path d="M29 305L29 307C29 311.418 32.5817 315 37 315L92 315" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M530 305L530 307C530 311.418 526.418 315 522 315L322 315" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M236 326L236 323C236 318.582 232.418 315 228 315L89 315" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M236 326L236 323C236 318.582 239.582 315 244 315L325 315" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="341.514" y="292.28">Все формы обучения</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="343.368" y="267.22">бюджета в приеме</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="306.459" y="251.22">Расчетная доля федерального</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" letter-spacing="0.01em" font-size="47"
          font-family="Raleway" style="white-space: pre" xml:space="preserve" fill="#263238"><tspan y="219.18" x="404">{{ $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getPdData.d * 100) ? (getPdData.d === 'н.д.' ? 'н.д.': 'x'): getPdData.d * 100, 1, 'float', true,  'н.д.', '', (v) => v + '%') }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="268" y="214.765">×</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="91.5137" y="292.28">Все формы обучения</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="67.6797" y="251.22">Потребность в приеме для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="154" y="267.22">{{
        getPdData.sprRegionNameGenitive
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="154" y="219.18">{{
        getPdData.pp
      }}</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="29" y="151.04">Заочная форма
</tspan></text>
    <line x1="30" y1="117.5" x2="938" y2="117.5" stroke="#CFD8DC"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="30" y="96.2402">Прогноз потребности в подготовке кадров осуществлен в разрезе регионов.</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="30" y="77.2402"><tspan style="font-weight: 600;">{{ getPdData.sprRegionName }}</tspan>, {{
        getPdData.sprKcpGroupSprUslName
      }}: {{ getPdData.sprKcpGroupId }} {{ getPdData.sprKcpGroupName }}.</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22"
          letter-spacing="0.01em"><tspan x="30" y="43.68">Прогнозирование общего объема КЦП для нестоличного региона
</tspan></text>
  </svg>
</template>

<script>
import request from "@/services/request";
import {svgPropsMapper} from "@/mixins/svgPropsMapper";

export default {
  name: "Pd3",
  mixins: [svgPropsMapper],
  props: {
    kcpGroupId: null,
    regionId: null,
  },
  data() {
    return {
      getPdData: {
        "id": 0,
        "sprKcpGroupId": "string",
        "sprKcpGroupName": "string",
        "sprKcpGroupSprUslName": "string",
        "sprRegionId": "string",
        "sprRegionName": "string",
        "sprRegionNameGenitive": "string",
        "pp": 0,
        "d": 0,
        "pbm": 0,
        "kcp23": 0,
        "kcp2": 0,
        "kcp3": 0,
        "br1": 0,
        "opPr1": 0,
        "kcp1": 0,
        "ppr": 0,
        "dppr": 0,
        "kcpR2": 0,
        "kcpR3": 0,
        "opps": 0,
        "okcpR1": 0,
        "dkcpR1": 0
      },
    }
  },
  async created() {
    await this.getPdSvg();
  },
  methods: {
    async getPdSvg() {
      try {
        const res = await request({
          endpoint: `/api/information/getPd?regionId=${this.regionId}&kcpGroupId=${this.kcpGroupId}`,
          method: 'get',
        });
        if (res.status === 200 ) {
          console.log('getPdSvg успех');
          if (res.data) {
            this.mapServerData(res.data);
          }else
            this.mapServerData();
        }
        this.changeDefaultValues()
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700');

text {
  font-feature-settings: 'pnum' on, 'lnum' on;
}
</style>